<template>
  <div class="apresentacoes-detalhes">
    <v-container align-center justify-center class="container">
      <Card v-if="apresentacao !== undefined && fail === false"
        v-bind:title="apresentacao.nome"
        v-bind:text="'Organizado por '+apresentacao.organizador"
        v-bind:subtext="datastring">
        <div class="descfield" v-if="apresentacao.descricao">
          <v-divider/>
          <v-textarea rows="1" auto-grow readonly label="Descrição" v-model="apresentacao.descricao"/>
        </div>
        <div class="detalhefield" v-if="apresentacao.repertorio">
          <v-divider/>
          <h2 class="label">Repertório</h2>
          <ul class="ul">
            <li v-for="musica in apresentacao.repertorio" v-bind:key="musica">{{musica}}</li>
          </ul>
        </div>

        <v-speed-dial
      v-model="fab"
      fixed right bottom
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="blue darken-2"
          dark
          fab
        >
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-btn
        fab
        dark
        small
        color="green"
        v-on:click.native="editar"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="red"
        @click.stop="deleteConfirm = true"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-speed-dial>
      </Card>
      <Card v-if="fail === true"
        title="Erro"
        color="red">
        Não foi possível encontrar esta apresentação
      </Card>
    </v-container>

    <v-dialog v-model="deleteConfirm" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Apagar Apresentação</v-card-title>
        <v-card-text>Tem certeza que deseja apagar esta apresentação? Esta operação é irreversível.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="deleteConfirm = false">Cancelar</v-btn>
          <v-btn color="red darken-1" text @click="deletar">Apagar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import Card from '@/components/Card.vue'
import { db } from '../main'

export default {
  name: 'detalhesapresentacao',
  components: {
    Card
  },
  props: ['apresentacaoid'],
  data () {
    return {
      apresentacao: undefined,
      boundquery: [],
      fail: false,
      deleteConfirm: false,
      fab: false
    }
  },
  methods: {
    editar: function (event) {
      this.$router.push({ name: 'Editar Apresentação', params: { apresentacaoid: this.apresentacaoid } })
    },
    deletar: function () {
      this.deleteConfirm = false
      db.collection('apresentacoes').where('codigo', '==', this.apresentacaoid).get().then(function (querySnapshot) {
        console.log(querySnapshot)
        querySnapshot.docs[0].ref.delete().then(function () {
          console.log('Document successfully deleted!')
          this.$router.push({ name: 'Apresentações' })
        }.bind(this)).catch(function (error) {
          console.error('Error removing document: ', error)
        })
      }.bind(this))
    }
  },
  computed: {
    datastring: function () {
      if (this.apresentacao.data && !this.apresentacao.dataprecisao) {
        return this.$moment(new Date(this.apresentacao.data.seconds * 1000)).format('DD/MM/YYYY')
      } else if (this.apresentacao.data && this.apresentacao.dataprecisao === 'mes') {
        return this.$moment(new Date(this.apresentacao.data.seconds * 1000)).format('MM/YYYY')
      } else if (this.apresentacao.data && this.apresentacao.dataprecisao === 'mes') {
        return this.$moment(new Date(this.apresentacao.data.seconds * 1000)).format('YYYY')
      } else {
        return 'Data a ser definida'
      }
    }
  },
  mounted () {
    const queryResult = this.$store.state.apresentacoes.find(x => x.codigo === this.apresentacaoid)
    this.fail = false
    if (queryResult) {
      console.log('Binding Apresentacao from store')
      // this.$unbind('apresentacao')
      this.apresentacao = queryResult
    } else {
      console.log('Binding Apresentacao from database')
      this.$bind('boundquery', db.collection('apresentacoes').where('codigo', '==', this.apresentacaoid)).then(function () {
        console.log(this.boundquery)
        if (!this.boundquery.length) {
          this.fail = true
        } else {
          this.apresentacao = this.boundquery[0]
        }
      }.bind(this))
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 800px;
}

h1 {
  font-size: 2rem;
  margin-top: 5px;
  margin-bottom: 0px;
  color: black;
}

.label {
  font-size: 1rem;
  font-style: normal;
  margin-bottom: 0.25em;
}

.organizadorfield {
  font-size: 1.5rem;
}
.main-card {
  margin: auto;
  margin-top: 20px;
  padding-top: 10px;
  padding: 16px;
  color: black;
  background-color: white;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

.title {
  margin-bottom: 20px;
}

.detalhefield {
  margin-top: 0.25rem;
  font-size: 1rem;
}

.descfield {
  margin-bottom: 20px;
  font-style: italic;
}

.adminoptions {
  background: #CCCCCC;
  margin-top: 20px;
  border-radius: 6px;
  padding: 10px;
}

.ul {
  margin-top: 5px;
}

.inviteoptions {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.refusebutton::v-deep {
  background: linear-gradient(0deg, #cc3333 0%, #ff5555 100%) !important;
  width: 100%;
  margin-top: 5px;
}

.acceptbutton::v-deep {
  width: 100%;
  margin-top: 10px;
}

.editbutton::v-deep {
  font-size: 1em;
  height: 2em;
  width: fit-content;
  padding-left: 10px;
  padding-right: 10px;
}
.editbutton {
  margin-top: 10px;
}

  /* Mobile Styles */
@media only screen and (max-width: 415px) {
  .main-card {
    width: 100%;
    margin-top: 0px;
  }
}

/* iphone XR */
@media only screen and (min-device-width : 414px) and (max-device-height : 896px) and (-webkit-device-pixel-ratio : 2) {
  .main-card {
    width: 100%;
    margin-top: 0px;
  }
}

/* Desktop Styles */
@media only screen and (min-width: 416px) {
  .main-card {
    max-width: 50%;
    -webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
    box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
    border-radius:6px;
    -moz-border-radius:6px;
    -webkit-border-radius:6px;
    }
}
</style>
